import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import classnames from "classnames";
import { Link } from "react-router-dom"; // Components

import Icon from "../Icon";
import "./Button.scss";
export var Button = function Button(a) {
  var b,
      c = a.type,
      d = a.size,
      e = a.color,
      f = a.icon,
      g = a.children,
      h = a.href,
      i = a.external,
      j = a.target,
      k = a.className,
      l = a.onClick,
      m = _objectWithoutProperties(a, ["type", "size", "color", "icon", "children", "href", "external", "target", "className", "onClick"]);

  c || (c = "button");
  var n = classnames("ta-btn", k, (b = {}, _defineProperty(b, "ta-btn__".concat(d), d), _defineProperty(b, "ta-btn__".concat(e), e), b));
  return h ? /*#__PURE__*/React.createElement(React.Fragment, null, i ? /*#__PURE__*/React.createElement("a", {
    href: h,
    target: j || "_blank",
    rel: "noopener noreferrer",
    className: n,
    onClick: l
  }, f && /*#__PURE__*/React.createElement(Icon, {
    icon: f
  }), g) : /*#__PURE__*/React.createElement(Link, {
    to: h,
    className: n,
    onClick: l
  }, f && /*#__PURE__*/React.createElement(Icon, {
    icon: f
  }), g)) : /*#__PURE__*/React.createElement(c, Object.assign({}, m, {
    className: n,
    onClick: l
  }), g, f && /*#__PURE__*/React.createElement(Icon, {
    icon: f
  }));
};
export default Button;